import React from 'react';
import Markdown from 'markdown-to-jsx';
import './ChatMarkdown.css';

// Links inside workflow-linked bubbles must not also focus the workflow node.
function ChatLink(props: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return <a {...props} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()} />;
}

// Shows an image's alt text instead of fetching the image.
function AltText({ alt }: React.ImgHTMLAttributes<HTMLImageElement>) {
  return alt ? <span>{alt}</span> : null;
}

interface ChatMarkdownProps {
  text?: string;
  /**
   * Render images as their alt text. For text a caller could have steered
   * (e.g. a user's memory): a remote image would be requested by whoever views it.
   */
  blockImages?: boolean;
}

export default function ChatMarkdown({ text = '', blockImages = false }: ChatMarkdownProps) {
  return (
    <Markdown className="chat-markdown" options={{
      forceBlock: true,
      forceWrapper: true,
      disableParsingRawHTML: true,
      overrides: {
        ...(blockImages ? { img: { component: AltText } } : {}),
        a: { component: ChatLink },
      },
    }}>
      {text}
    </Markdown>
  );
}
